module.exports = __webpack_public_path__ + "static/img/liren.18ca095.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/all-versions/liren.png
// module id = 891
// module chunks = 2